import React from 'react';
import { GameProgressEntry } from '../../types';

interface GameStatsGridProps {
  games: GameProgressEntry[];
  rpgLevel?: number | null;
}

const GAME_META: Record<string, { label: string; icon: string; unit: string }> = {
  'timed-race': { label: 'Timed Race', icon: '⏱️', unit: 'WPM' },
  'word-burst': { label: 'Word Burst', icon: '💥', unit: 'pts' },
  'bubble-pop': { label: 'Bubble Pop', icon: '🫧', unit: 'pts' },
  'falling-words': { label: 'Falling Words', icon: '🌧️', unit: 'pts' },
  'search-of-the-67': { label: 'In Search of the 67', icon: '🗝️', unit: 'keys' },
  'space-defender': { label: 'Space Defender', icon: '🚀', unit: 'pts' },
  'key-beats': { label: 'Key Beats', icon: '🎵', unit: 'pts' },
  'picture-spell': { label: 'Picture Spell', icon: '🐝', unit: 'pts' },
  'number-ninja': { label: 'Number Ninja', icon: '🥷', unit: 'pts' },
  'memory-flash': { label: 'Memory Flash', icon: '🧠', unit: 'pts' },
  'story-builder': { label: 'Story Builder', icon: '📖', unit: 'WPM' },
  'block-miner': { label: 'Block Miner', icon: '⛏️', unit: 'pts' },
  'obby-run': { label: 'Obby Run', icon: '🏃', unit: 'pts' },
};

const GameStatsGrid: React.FC<GameStatsGridProps> = ({ games, rpgLevel }) => {
  const played = games.filter(g => g.total_attempts > 0);

  if (played.length === 0 && !rpgLevel) {
    return <p className="text-gray-500 text-center py-4">No games played yet -- try one from the Games tab!</p>;
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {played.map(g => {
        const meta = GAME_META[g.game_name] || { label: g.game_name, icon: '🎮', unit: 'pts' };
        return (
          <div key={g.game_name} className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-center">
            <div className="text-2xl mb-1">{meta.icon}</div>
            <div className="text-sm font-semibold text-gray-800">{meta.label}</div>
            <div className="text-xs text-gray-500 mt-1">
              Best: <span className="font-bold text-blue-600">{g.high_score} {meta.unit}</span>
            </div>
            <div className="text-xs text-gray-400">{g.total_attempts} attempt{g.total_attempts === 1 ? '' : 's'}</div>
          </div>
        );
      })}
      {!!rpgLevel && (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-center">
          <div className="text-2xl mb-1">🐉</div>
          <div className="text-sm font-semibold text-gray-800">Typing RPG</div>
          <div className="text-xs text-gray-500 mt-1">
            Level: <span className="font-bold text-blue-600">{rpgLevel + 1}</span>
          </div>
          <div className="text-xs text-gray-400">in progress</div>
        </div>
      )}
    </div>
  );
};

export default GameStatsGrid;
